/* styles.ts generated by @compiled/babel-plugin v0.29.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import { forwardRef } from 'react';
import * as React from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _14 = "@media (min-width:64rem){._10m437uc{flex-grow:8}._1vdkkb7n{flex-shrink:1}._1wznf1ug{flex-basis:0%}}";
const _13 = "._i0dl1osq{flex-basis:100%}";
const _12 = "@media (min-width:64rem){._10m4egat{flex-grow:4}._1vdkkb7n{flex-shrink:1}._1wznf1ug{flex-basis:0%}}";
const _11 = "._1bsb1osq{width:100%}";
const _10 = "._i0dlf1ug{flex-basis:0%}";
const _9 = "._1o9zkb7n{flex-shrink:1}";
const _8 = "._16jlkb7n{flex-grow:1}";
const _7 = "@media (min-width:64rem){._1jsv1y6m{align-items:flex-start}._1inivrvc{flex-direction:row}}";
const _6 = "._zulpxy5q{gap:var(--ds-space-400,2pc)}";
const _5 = "._1bah1h6o{justify-content:center}";
const _4 = "._4cvr1h6o{align-items:center}";
const _3 = "._2lx21bp4{flex-direction:column}";
const _2 = "._1e0c1txw{display:flex}";
import { media } from '@atlaskit/primitives';
const _ = "._otyrxy5q{margin-bottom:var(--ds-space-400,2pc)}";
export const TaglineContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_otyrxy5q", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  TaglineContainer.displayName = 'TaglineContainer';
}
export const Columns = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_2, _3, _4, _5, _6, _7]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _zulpxy5q _1jsv1y6m _1inivrvc", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Columns.displayName = 'Columns';
}
export const LeftColumn = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_8, _9, _10, _11, _12]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _1bsb1osq _10m4egat _1vdkkb7n _1wznf1ug", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  LeftColumn.displayName = 'LeftColumn';
}
export const RightColumn = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_8, _9, _13, _11, _14]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_16jlkb7n _1o9zkb7n _i0dl1osq _1bsb1osq _10m437uc _1vdkkb7n _1wznf1ug", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  RightColumn.displayName = 'RightColumn';
}